<!-- Title -->
<div class="mat_dialog_head mt-4">
  <!-- Dialog Heading -->
  <h1 class="sub_title_1 text_dark_blue mb-0" mat-dialog-title *ngIf="!isAbhaVerification && !isOtpVerification">
    {{ 'shared.Verify_Mobile_Number' | translate }}
  </h1>
  <h1 class="sub_title_1 text_dark_blue mb-0" mat-dialog-title *ngIf="isAbhaVerification">{{ 'shared.Verify_ABHA_Number' | translate }}</h1>
  <h1 class="sub_title_1 text_dark_blue mb-0" mat-dialog-title *ngIf="isOtpVerification">{{ 'shared.Verify_OTP' | translate }}</h1>

  <!-- <ng-template #AbhaVerification>
    <h1 class="sub_title_1 text_dark_blue mb-0" mat-dialog-title>{{ 'shared.Verify_ABHA_Number' | translate }}</h1>
  </ng-template> -->

  <!-- Close Button -->
  <button class="btn_close" type="button" mat-dialog-close><i class="demo-icon icon-close"></i></button>
</div>

<!-- Border Line -->
<p class="border-line"></p>

<!-- Content -->
<mat-dialog-content class="mat-typography">
  <div class="align-items-end d-flex justify-content-between mb-3" *ngIf="!isAbhaVerification">
    <div class="text_dark_blue">
      <p>{{ 'shared.We_have_sent_an_OTP_to' | translate }}</p>
      <p class="text_bold">{{ countryCode }} | {{ mobileNumber }}</p>
    </div>

    <!-- Change Button -->
    <div *ngIf="isChangeMobile">
      <button class="btn btn-change" mat-dialog-close>{{ 'shared.Change' | translate }}</button>
    </div>
  </div>

  <div class="align-items-end d-flex justify-content-between mb-3" *ngIf="isAbhaVerification">
    <div class="text_dark_blue">
      <p>{{ 'shared.We_have_sent_an_OTP_to_the_registered_mobile_number' | translate }}</p>
    </div>
  </div>

  <!-- Verify Form -->
  <form [formGroup]="verifyOtpForm">
    <!-- OTP -->
    <div class="col-md-12">
      <mat-form-field class="no-bottom-wrapper otp-field" appearance="fill">
        <mat-label>{{ 'shared.OTP' | translate }}</mat-label>
        <input matInput formControlName="otp" />
      </mat-form-field>
      <mat-error *ngIf="verifyOtpForm.get(['otp'])?.hasError('pattern')">
        {{ 'shared.Please_enter_a_valid_OTP' | translate }}
      </mat-error>
      <mat-error
        *ngIf="!verifyOtpForm.get(['otp'])?.hasError('pattern') && verifyOtpForm.get(['otp'])?.hasError('minlength')">
        {{ 'shared.Please_enter_a_valid_OTP' | translate }}
      </mat-error>
      <mat-error
        *ngIf="!verifyOtpForm.get(['otp'])?.hasError('pattern') && verifyOtpForm.get(['otp'])?.hasError('maxlength')">
        {{ 'shared.Maximum_limit_of_6_digits_exceeded' | translate }}
      </mat-error>
    </div>
  </form>
</mat-dialog-content>

<!-- Action Buttons -->
<mat-dialog-actions class="d-flex justify-content-between pb-4 px-4">
  <!-- Cancel -->
  <button class="btn btn_brdr_lc2" mat-dialog-close>{{ 'shared.Cancel' | translate }}</button>

  <!-- Verify -->
  <button class="btn btn_primary" [disabled]="verifyOtpForm.invalid" (click)="onClickVerify()">Verify</button>
</mat-dialog-actions>
